module.exports = __webpack_public_path__ + "img/circuit-guy-light.9df3af4f.svg";